/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsShield: {
  name: 'shield';
  data: string;
} = {
  name: 'shield',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.224 1.67a.5.5 0 0 0-.448 0l-5 2.5a.454.454 0 0 0-.261.423c.262 5.143 3.88 8.513 5.264 9.618a.345.345 0 0 0 .441 0c1.385-1.105 5.003-4.475 5.265-9.618a.454.454 0 0 0-.261-.422l-5-2.5ZM7.329.777a1.5 1.5 0 0 1 1.342 0l5 2.5c.503.252.843.777.813 1.368-.285 5.586-4.195 9.196-5.64 10.349a1.345 1.345 0 0 1-1.688 0C5.71 13.84 1.8 10.23 1.516 4.643c-.03-.59.31-1.115.813-1.367l5-2.5Z" fill="currentColor"/></svg>`,
};
